import { useMutation } from '@tanstack/react-query';

import api from '@/hooks/useApi';

export type SupportCategory =
  'bug' | 'account' | 'tokens' | 'content' | 'feature' | 'feedback' | 'other';

export interface SupportRequest {
  subject: string;
  message: string;
  category?: SupportCategory;
}

interface SupportResponse {
  success: true;
}

async function submitSupportRequest(request: SupportRequest): Promise<SupportResponse> {
  const { data } = await api.post<SupportResponse>('/support', request);
  return data;
}

export function useSupport() {
  return useMutation({
    mutationFn: submitSupportRequest,
  });
}
